import Button from "./Button.jsx";
import { Column } from "./Table.jsx";
import GenericUtils from "../../lib_react_frontend/utils/GenericUtils.jsx";
import Input from "./Input.jsx";
import ModalSearch from "./ModalSearch.jsx";
import React from "react";
import ReactTooltip from "react-tooltip";
import { toastr } from "react-redux-toastr";

/**
 * Componente padrão da apice de buscar registros no banco de dados.
 */
export default class ApiceComboEditPanel extends React.Component {
  static inputId = 0;

  constructor() {
    super();
    this.id = "apice-combo-edit-panel-" + ApiceComboEditPanel.inputId++;
    this.state = {
      desc: "",
      registros: [],
      ultimoCodigoValido: "",
      valorOnFocus: 0, // Valor ao entrar no onFocus
    };
  }

  /**
   * @override
   */
  componentDidMount() {
    // if (this.props.dinamico) {
    //   return;
    // }

    if (this.props.value > 0) {
      this.carregarRegistros();
    }
  }

  /**
   * @override
   */
  async componentWillReceiveProps(nextProps) {
    if (nextProps.where !== this.props.where) {
      await this.carregarRegistros(nextProps.where);
    }
    if (nextProps.value !== this.props.value) {
      if (this.props.buscarNoEnter) {
        return;
      }
      await this.carregarRegistros();
      this.carregarDesc(nextProps.value);
    }
  }

  /**
   * Handler do onChange do input de código.
   */
  onChange(e) {
    //if (this.props.dinamico) {
    if (this.props.buscarNoEnter) {
      if (this.props.onChange) {
        this.props.onChange(e);
      }
      return;
    }

    this.carregarRegistros(
      this.props.chavePrefix
        ? `${this.props.chavePrefix}.${this.props.chave} = ${
            this.props.retornaObjeto
              ? e.target.value[this.props.chave]
              : e.target.value
          }`
        : `${this.props.chave} = ${
            this.props.retornaObjeto
              ? e.target.value[this.props.chave]
              : e.target.value
          }`
    );
    //}

    if (this.props.onChange) {
      this.props.onChange(e);
    }
    this.carregarDesc(e.target.value);
  }

  /**
   * Chamado quando o input perde o foco.
   */
  onBlur() {
    if (this.props.exibeMensagemNaoEncontrado && this.state.retornaFoco) {
      if (this.props.onChange) {
        const obj = {
          target: {
            value: "",
          },
        };
        this.props.onChange(obj);
      }
      setTimeout(() => {
        this.campoCodigo.focus();
      }, 50);
      this.setState({
        retornaFoco: false,
      });

      return;
    }
    if (
      this.state.ultimoCodigoValido === "" &&
      this.campoCodigo.props.value === ""
    ) {
      return;
    }

    if (!this.props.zeraCampo) {
      if (!this.state.desc) {
        this.onChange({
          target: {
            value: this.state.ultimoCodigoValido,
          },
        });
      }
    }
    if (this.campoCodigo.props.value === "") {
      this.onChange({ target: { value: 0 } });
    }
    if (this.props.onBlur) {
      this.props.onBlur(this.state.valorOnFocus !== this.props.value);
    }
  }

  /**
   * Chamado quando o input ganha o foco.
   */
  onFocus() {
    this.setState({ valorOnFocus: this.props.value });
  }

  /**
   * Chamado quando o modal de pesquisa for confirmado.
   */
  async onConfirmModal(registro) {
    if (!registro) {
      if (this.props.retornaFoco) {
        this.props.retornaFoco();
      }
      return;
    }
    if (this.props.retornoNoEnter) {
      this.carregarRegistros("", true);
    }
    if (this.props.retornaObjeto) {
      this.onChange(
        {
          target: {
            value: registro,
          },
        },
        true
      );
      return;
    }

    this.onChange({
      target: {
        value: registro[this.props.chave],
      },
    });
    if (this.props.onConfirm) {
      this.props.onConfirm();
    }

    if (this.props.retornaFoco) {
      this.props.retornaFoco();
    }
  }

  async onEscape() {
    if (this.props.retornaFoco) {
      this.props.retornaFoco();
    }
  }

  /**
   * Retorna o objeto de Api para uso no backend.
   */
  getApi() {
    if (this.props.api) {
      return this.props.api;
    }
    throw new Error(
      "API não especificada para o componente ApiceComboEditPanel!"
    );
  }

  /**
   * Retorna o campo de descrição do painel desabilitado.
   */
  getDesc() {
    return this.state.desc;
  }

  /**
   * Carrega o campo de descrição com base no código que está escrito.
   */
  carregarDesc(codigo, nao_adiciona) {
    if (codigo && this.state.registros && this.state.registros.length > 0) {
      const reg = this.state.registros.find(
        (x) => x[this.props.chave] === codigo
      );
      if (reg && reg[this.props.desc]) {
        this.setState(
          { desc: reg[this.props.desc], ultimoCodigoValido: codigo },
          () => {
            if (this.props.getDesc) {
              this.props.getDesc(this.state.desc);
            }
          }
        );
        if (this.props.retornoNoEnter) {
          this.props.retornoNoEnter(reg, nao_adiciona);
        }
      } else {
        this.setState({ desc: "" });
        if (this.props.exibeMensagemNaoEncontrado) {
          this.setState({
            retornaFoco: true,
          });
          toastr.error("Atenção", "Produto não encontrado", { timeOut: 10000 });
        }
      }
    } else {
      this.setState({ desc: "" });
    }
  }

  /**
   * Carrega os registros do banco de dados.
   */
  async carregarRegistros(where, nao_adiciona) {
    GenericUtils.setElementoCarregando(this.divPrincipal, true, "2");

    let validacao_where = "";

    if (where) {
      validacao_where += where;
    } else if (this.props.where) {
      validacao_where += where ? where + this.props.where : this.props.where;
    }

    const Api = this.getApi();
    const valida_where =
      this.props.nao_envia_chave && this.props.where
        ? this.props.where
        : validacao_where || "";
 
    const ret = await Api.buscar(this.props.tabela, "", valida_where);

    if (ret.status) {
      this.setState({ registros: ret.dados }, () => {
        GenericUtils.setElementoCarregando(this.divPrincipal, false);
        this.carregarDesc(this.props.value, nao_adiciona);
      });
    }
  }

  limparUltimoCodigoValidado() {
    this.setState({ ultimoCodigoValido: 0 });
  }

  /**
   * Retorna o where da pesquisa do modal.
   */
  // getWherePesquisa(texto) {

  //   if (
  //     this.props.desc &&
  //     this.props.desc == "a.nome_lote" &&
  //     !this.props.semFiltroWhere
  //   ) {
  //     return `${this.props.where ? this.props.where : ""}
  //           ${
  //             this.props.desc && !this.props.semFiltroWhere
  //               ? " AND  " +
  //                 "( a.nome_lote" +
  //                 ` like '%${texto}%'` +
  //                 "OR b.nome" +
  //                 ` like '%${texto}%' )`
  //               : ""
  //           }`;
  //   } else {
  //     return `${this.props.where ? this.props.where : ""}
  //           ${
  //             this.props.desc && !this.props.semFiltroWhere
  //               ? " AND  " + this.props.desc + ` like '%${texto}%'`
  //               : ""
  //           }`;
  //   }
  // }

  getWherePesquisa(texto) {
    return `${this.props.where ? this.props.where : ""}
            ${
              this.props.desc && !this.props.semFiltroWhere
                ? " AND  " + this.props.desc + ` like '%${texto}%'`
                : ""
            }`;
  }

  /**
   * Abre a pesquisa.
   */
  async mostrarPesquisa(filtro) {
    if (typeof filtro === "object") {
      filtro = "";
    }

    await this.modal.show(() => {
      if (this.props.value) {
        // Se tem um código definido.
        this.modal.selecionarRegistroByCampo(
          this.props.chave,
          this.props.value
        );
      }
      if (this.props.tirarZindex) {
        this.props.tirarZindex();
      }
    }, filtro);
  }

  /**
   * Renderiza as colunas da pesquisa.
   */
  renderColunasPesquisa() {
    return this.props.colunas
      ? this.props.colunas.map((x) => (
          <Column
            key={x.props.field}
            className={x.props.className}
            style={x.props.style}
            header={x.props.header}
            field={x.props.field}
          />
        ))
      : [];
  }

  async fecharModal() {
    await this.modal.hide();
  }

  render() {
    return (
      <div className="relative" ref={(e) => (this.divPrincipal = e)}>
        {this.props.label && (
          <label htmlFor={this.id}>{this.props.label}</label>
        )}

        <div className="input-group d-flex flex-row mb-5">
          {/* Input do código: */}
          {/* <ReactTooltip id={this.id}>
            <span>F4 - Consultar</span>
          </ReactTooltip> */}

          {!this.props.escondeInput && (
            <Input
              value={this.props.value}
              data-tip
              data-for={this.id}
              data-event="focus"
              style={{ width: "550px !important" }}
              data-event-off="blur"
              onChange={this.onChange.bind(this)}
              onBlur={this.onBlur.bind(this)}
              ref={(e) => (this.campoCodigo = e)}
              onFocus={this.onFocus.bind(this)}
              disabled={this.props.disabled}
              onKeyEnter={async () => {
                if (this.props.onKeyEnter) {
                  this.props.onKeyEnter();
                  return;
                }
                if (this.props.buscarNoEnter) {
                  await this.carregarRegistros();
                  // this.carregarDesc(this.props.value);
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "F4") {
                  if (this.props.onPressF4) {
                    return this.props.onPressF4();
                  }
                  this.modal.show();
                }
                if (this.props.onKeyDown) {
                  this.props.onKeyDown(e);
                }
              }}
              id={this.id}
              className={
                "cod-apice-panel flex-wrap " +
                this.props.tamanhoTelaInputscodigo +
                " "
              }
            />
          )}

          {/* Botão da lupa: */}
          {!this.props.escondeLupa && (
            <span className="input-group-bxtn flex-wrap">
              <Button
                icon="fa-search"
                tabIndex="-1"
                className={"btn-flat btn-system-color " + this.props.btnClass}
                disabled={this.props.disabled}
                onClick={() => this.mostrarPesquisa()}
              />
            </span>
          )}

          {/* Descrição: */}
          {!this.props.escondeDescricao && (
            <Input
              disabled
              value={this.state.desc}
              className={"flex fw " + this.props.descInputClass}
            />
          )}

          {this.props.clearButton && (
            <span className="input-group-bxtn flex-wrap">
              <Button
                icon="fa-times"
                tabIndex="-1"
                className={"btn-flat btn-danger " + this.props.btnClearClass}
                onClick={this.props.onClearClick}
                disabled={this.props.disabled}
              />
            </span>
          )}

          {this.props.btnDireito ? (
            <span className="input-group-bxtn flex-wrap">
              <Button tabIndex="-1" {...this.props.btnDireito} />
            </span>
          ) : null}
        </div>

        <ModalSearch
          titulo="Pesquisa de registros"
          ref={(e) => (this.modal = e)}
          tabela={this.props.tabela}
          desc={this.props.desc}
          descs={this.props.descs}
          afterCancel={this.props.afterCancel}
          onEscape={this.onEscape.bind(this)}
          sem_fechar_double_click={this.props.sem_fechar_double_click}
          api={this.getApi()}
          buttonsHeader={this.props.buttonsHeader}
          botoes={this.props.botoes}
          pagination={this.props.pagination}
          tableMaxHeight={this.props.tableMaxHeight ? this.props.tableMaxHeight : 400}
          renderColunas={this.renderColunasPesquisa.bind(this)}
          getWhere={this.getWherePesquisa.bind(this)}
          onConfirm={this.onConfirmModal.bind(this)}
          modalStyle={this.props.modalStyle}
          confirmaFiltro={this.props.confirmaFiltro}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib_react_adminlte/componentes/ApiceComboEditPanel.jsx